import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

import { MenuItem } from "@mui/material";
import Chip from '@mui/material/Chip';

import { useColors } from "../../Context/ColorsContext"
import { MediaQuerys } from "../../styles/GlobalStyle";

const { mobile, tablet, desktop } = MediaQuerys;

export const PageTitle = styled('p')(() => {
  const { colors } = useColors();
  return {
    color: colors.titleTextColor,
    alignContent: "center",
	  textAlign: "left",
    fontWeight: "700",
    fontSize: '24px',
    [mobile]: {
      fontSize: '18px',
    },
  };
});

export const DownloadButton = styled(Button)(({ bRadius }) => {
    const { colors } = useColors();
    return {
        height: '100%',
        width: '100%',
        padding: "0 20px",
        backgroundColor: colors.buttonActionColor,
        color: colors.white,
		borderRadius: bRadius || null,
        "&:hover": {
            backgroundColor: colors.buttonActionColor,
            opacity: 0.9,
            color: colors.white
        }
    }
})

export const TemplateButton = styled(Button)(({ bRadius }) => {
    const { colors } = useColors();
    return {
        height: '100%',
        width: '100%',
        padding: "0 20px",
        backgroundColor: colors.buttonActionColor,
        color: colors.white,
		borderRadius: bRadius || null,
        "&:hover": {
            backgroundColor: colors.buttonActionColor,
            opacity: 0.9,
            color: colors.white
        }
    }
})

export const ContainerButtonCreate = styled('div')(() => ({
	width: 170,
	height: 40,
	[desktop]: {
		width: "120px",
		height: "30px",
		"& button": {
			padding: "14px 12px",
			fontSize: "0.55rem",
		},
	},
	[tablet]: {
		width: "110px",
		height: 20,
		"& button": {
			fontSize: "7px",
		},
	},
}))

export const ContainerButtonSmall = styled('div')(() => ({
	width: 50,
	height: 40,
	[desktop]: {
		height: "30px",
		"& button": {
			padding: "14px 12px",
			fontSize: "0.55rem",
		},
	},
	[tablet]: {
		height: 20,
		"& button": {
			fontSize: "7px",
		},
	},
}))

  export const CustomMenuItem = styled(MenuItem)(() => {
	return {
    display: "flex",
    flexDirection: "row",
    gap: "10px",
	  [desktop]: {
		"& .MuiTouchRipple-root": {
      	fontSize: "0.75rem",
    	},
	  },
	};
  });

  export const CustomBtn = styled(Button)(() => {
	const { colors } = useColors();
	return {
        backgroundColor: colors.buttonActionColor,
		height: 40,
		[desktop]: {
			width: "85px",
			height: "30px",
			fontSize: "0.65rem",
		  },
		  [tablet]: {
			width: "100px",
			height: 28,
			fontSize: "7px",
		},
		"&:hover": {
            backgroundColor: colors.buttonActionColor,
            opacity: 0.9,
            color: colors.white
        }
	}
})


export const ButtonsGroup = styled('div')(() => {
	return {
		display: 'flex',
		flexDirection: 'row',
		gap: '0.7rem'
	}
})

export const TrainingStatus = styled("span")(() => {
  const { colors } = useColors();
  return {
    color: colors.green,
    fontWeight: "bold"
  }
})


export const RoleCertificate = styled("span")(({isValid}) => {
  const { colors } = useColors();
  return {
    color: isValid === true ? colors.green : isValid === false ? colors.darkOrange : colors.default
  }
})

export const StyledChip = styled(Chip)(({ isSpecial, isError, isInvalid }) => {
  return {
    backgroundColor: isInvalid == true ? "#FFE08A" : (isError ? "#ffe3e3" : (isSpecial ? "#cefadc" : "#f3f3f3")),
    color: isInvalid == true ? "#7A5200" : (isError ? "#af4545" : (isSpecial ? "#66ae87" : "#555555")),
    fontWeight: "bold",
    height: "auto",
    minHeight: "24px",
    fontSize: "12px",
    marginRight: "4px",
    marginBottom: "4px",
    ".MuiChip-label": {
      padding: "2px 8px",
      display: "flex",
      alignItems: "center",
    },
    ".MuiChip-icon": {
      color: "inherit",
      marginLeft: "8px",
    }
  };
});

export const CustomIconArea = styled("div")(() => {
  return {
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "transparent",
    border: "1px solid #e9e9e9",
    borderRadius: "8px",
    color: "#4a4a4a",
    padding: "2px 6px",
    fontSize: "11px",
    fontWeight: "bold",
    height: "24px",
    marginLeft: "2px",
    cursor: "default"
  };
});

